import type { AppType } from "@assetwatch/work-api/app";
import { hc } from "hono/client";
import { authenticatedFetch } from "./authenticatedFetch";

const configuredApiBaseUrl = (
  import.meta.env.VITE_WORK_API_BASE_URL as string | undefined
)?.replace(/\/$/, "");
const configuredApiPathPrefix = (
  import.meta.env.VITE_WORK_API_PATH_PREFIX as string | undefined
)?.trim();

const workApiBaseUrl = configuredApiBaseUrl ?? window.location.origin;
const workApiPathPrefix =
  configuredApiPathPrefix === null || configuredApiPathPrefix === undefined
    ? "/work"
    : configuredApiPathPrefix === ""
      ? ""
      : configuredApiPathPrefix.startsWith("/")
        ? configuredApiPathPrefix.replace(/\/$/, "")
        : `/${configuredApiPathPrefix.replace(/\/$/, "")}`;

export const workClient = hc<AppType>(`${workApiBaseUrl}${workApiPathPrefix}`, {
  fetch: authenticatedFetch,
});

export function workApiFetch(path: string, init?: RequestInit) {
  return authenticatedFetch(
    `${workApiBaseUrl}${workApiPathPrefix}${path}`,
    init,
  );
}
